import gql from 'graphql-tag'
import cl from './client'

var client = cl.get()

export default {
  // User Stats
  get_testers: _ =>
    client
      .query({
        // prettier-ignore
        query:gql`query{
          testers{ id, name }
        }`
      })
      .then(res => res.data.testers),
  get_user_stats: batchid =>
    client
      .query({
        // prettier-ignore
        query: gql`query($batchid: ID!){
          batch(id: $batchid){
            userStats{
              batchId, userId, numAnsCorrect, numAnsWrong, numCheck, timeSimpleCheckQuartiles, timeDetailCheckQuartiles,numReportByVerified
            }
          }
        }`,
        variables: { batchid: batchid }
      })
      .then(res => (res.data.batch ? res.data.batch.userStats : {}))
}
